import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/PharmacyIllustration.tsx
const PharmacyIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "pharmacy.svg",
		alt: t("illustration.imageAlt.pharmacy")
	});
};

//#endregion
export { PharmacyIllustration };